import {
  createFileRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/my-components/(pages)/(list)/components',
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === '/my-components/components' ||
      location.pathname === '/my-components/components/'
    ) {
      throw redirect({ to: '/my-components/components/active' });
    }
  },
  component: lazyRouteComponent(
    () => import('../../../-components/ComponentsLayout'),
    'ComponentsLayout',
  ),
});
